<template>
  <base-material-card :icon="resource.icon" :title="title">
    <template v-slot:subtitle>
      <info-text i18n="integrations.forms.title.list" />
    </template>
    <va-list :filters="filters" disable-create :sort-by="['created_at']" :sort-desc="[true]" disable-export>
      <template v-slot:actions="slotProps">
        <export-poll-button :resource="resource.name" text :options="slotProps.listState.options" :filter="slotProps.currentFilter" />
      </template>
      <va-data-table :fields="fields" disable-edit disable-clone disable-delete disable-select></va-data-table>
    </va-list>
  </base-material-card>
</template>

<script>
import i18n from "@/i18n";
import { stateVariants } from "@/resources/formsubmissions/helper";
import InfoText from "@/components/helper/InfoText";
import ExportPollButton from "../../components/export/ExportPollButton";

export default {
  components: { ExportPollButton, InfoText },
  props: ["resource", "title"],
  data() {
    return {
      fields: [
        {
          label: i18n.t("integrations.fields.type"),
          source: "form",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.channel"),
          source: "channel_data",
          type: "reference",
          sortable: true,
          attributes: {
            reference: "channels",
            action: null
          }
        },
        {
          label: i18n.t("integrations.fields.title"),
          source: "title",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.submitter"),
          source: "submitter",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.assignee"),
          source: "assignee",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.state"),
          source: "state",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.updated_at"),
          source: "updated_at",
          type: "date",
          sortable: true
        },
        {
          label: i18n.t("integrations.fields.created_at"),
          source: "created_at",
          type: "date",
          sortable: true
        }
      ],
      filters: [
        {
          label: i18n.t("integrations.fields.channel"),
          source: "channel",
          type: "autocomplete",
          alwaysOn: true,
          resettable: true,
          attributes: {
            reference: "channels_globals_as_defaults",
            searchQuery: "q",
            sortBy: ["name"]
          }
        },
        {
          label: i18n.t("integrations.fields.status"),
          source: "state",
          type: "select",
          attributes: {
            choices: stateVariants,
            itemText: "name",
            itemValue: "id"
          },
          alwaysOn: true,
          resettable: true
        }
      ]
    };
  }
};
</script>
